export default {
  list: [
    {
      value: 'NEW_RESERVE_SUBMITTED',
      title: ' رزرو جدید ',
      content: 'یک رزرو جدید ثبت شد',
    },
    {
      value: 'RESERVE_WAS_CANCELLED',
      title: 'لغو رزرو',
      content: 'رزرو توسط مشتری لغو شد',
    },
    {
      value: 'RESERVES_ENDED_AUTOMATICALLY_SUSPENDED',
      title: 'بلاتکیف شدن رزرو',
      content:
        'بلاتکیف شدن خودکار رزروهایی  که از زمان پایان آن ها یک ساعت و نیم گذشته است',
    },
    {
      value: 'RESERVE_REQUESTS_AUTOMATICALLY_TIME_ELAPSED',
      title: 'کنسل شدن رزرو',
      content: 'RESERVE_REQUESTS_AUTOMATICALLY_TIME_ELAPSED',
    },
    {
      value: 'RESERVE_REQUESTS_AUTOMATICALLY_APPROVED',
      title: 'تایید خودکار رزرو',
      content: 'تایید خودکار رزروهای ثبت شده بیش از ۵ دقیقه پیش',
    },
    {
      value: 'NEW_PRINT_REQUEST_FROM_TABLET',
      title: 'درخواست پرینت از سمت تبلت',
      content: 'NEW_PRINT_REQUEST_FROM_TABLET',
    },
  ],
  values: {
    NEW_RESERVE_SUBMITTED: 'NEW_RESERVE_SUBMITTED',
    RESERVE_WAS_CANCELLED: 'RESERVE_WAS_CANCELLED',
    RESERVES_ENDED_AUTOMATICALLY_SUSPENDED:
      'RESERVES_ENDED_AUTOMATICALLY_SUSPENDED',
    RESERVE_REQUESTS_AUTOMATICALLY_TIME_ELAPSED:
      'RESERVE_REQUESTS_AUTOMATICALLY_TIME_ELAPSED',
    RESERVE_REQUESTS_AUTOMATICALLY_APPROVED:
      'RESERVE_REQUESTS_AUTOMATICALLY_APPROVED',
      NEW_PRINT_REQUEST_FROM_TABLET : 'NEW_PRINT_REQUEST_FROM_TABLET'
  },
};
